import React from 'react';
import FA from 'react-fontawesome';
import MyAvatar from './MyAvatar';

function Cover() {
    return (
        <section className="hero has-text-centered cover cover-compact">
            <div className="hero-body">
                <div className="container">
                    <div className="columns is-centered">
                        <div className="column is-8-desktop is-10-tablet">
                            <p className="eyebrow">Hey, I&apos;m</p>
                            <h1
                                className="title is-spaced is-size-1-desktop is-size-2-tablet is-size-3-mobile"
                                id="headtitle"
                            >
                                Samet Aslan
                            </h1>
                            <p className="role-line">Full-Stack Developer</p>

                            <div className="avatar-wrap">
                                <MyAvatar />
                            </div>

                            <p className="tagline">
                                I build practical software, automation, and mobile apps.
                            </p>

                            <div className="buttons is-centered">
                                <a
                                    className="button is-rounded btn-ghost"
                                    href="https://github.com/Samet-Aslan"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <span className="icon is-small">
                                        <FA name="github" />
                                    </span>
                                    <span>GitHub</span>
                                </a>
                                <a
                                    className="button is-rounded btn-ghost"
                                    href="mailto:hello@samet-aslan.de"
                                >
                                    <span className="icon is-small">
                                        <FA name="envelope" />
                                    </span>
                                    <span>Email</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Cover;
